import React from 'react';
import { Modal, Input, Form, Select, Icon, DatePicker, Button, Divider } from 'antd';
import dialog from '../../../common/utility/dialog';
import moment from "moment";
import { FORMAT_2DECIMALS, FORMAT_3DECIMALS, FORMAT_5DECIMALS, GREATER_THAN_ZERO } from "../../../common/types/regularExpresionType";
import global from '../../../common/utility/global';

const { Option } = Select;
const InputGroup = Input.Group;
const { Search } = Input;
class FormModal extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
        }
    }

    handleCompleteDecimals = (property, value) => {
        if (value === "" || isNaN(parseFloat(value).toFixed(3)))
            this.props.form.setFieldsValue({ [property]: "0.000" });
        else
            this.props.form.setFieldsValue({
                [property]: parseFloat(value).toFixed(3),
            });
    };

    handleFilter = (e) => {

        if (this.props.formValues.listaEmpleado.length > 0) {

            var filteredValue = this.props.formValues.listaEmpleado.filter(function (item) {
                return item.numeroDocumento == e;
            });

            if (filteredValue.length > 0) {

                this.props.onFilter(filteredValue)

            } else {
                dialog.error('No encontro el resultado');

            }
        } else {

            dialog.error('No encontro el resultado');

        }

    }

    handleCancel = () => {
        this.props.onClose();
        this.props.form.resetFields();
    }

    handleOk = (e) => {
        e.preventDefault();
        this.props.form.validateFieldsAndScroll((err, values) => {

            if (!err) {
                const form = {
                    id: values.id,
                    serie: values.serie,
                    correlativo: values.correlativo,
                    fechaTipoCambio: values.FechaTipoCambio.format("DD/MM/YYYY"),
                    tipoCambio: parseFloat(values.TipoCambio),
                    idEstablecimiento: values.idEstablecimiento.key,
                    idCaja: values.idCaja.key,
                    fechaReferencial: values.fechaReferencial.format("DD/MM/YYYY"),
                    nroEmpleado: '',
                    empleado: '',
                    idEmpleado: values.idResponsable.key,
                    saldoInicialSoles: parseFloat(values.saldoSoles),
                    saldoInicialDolares: parseFloat(values.saldoDolares),
                }

                const validFormLogic = this.validateFormLogic(form, values);
                if (!validFormLogic) {
                    return;
                }
                this.props.onSave(form, this.props.form);
            }
        });
    }

    validateFormLogic = (data, values) => {

        if (data.idEmpleado === 0) {
            dialog.warning(
                "Responsable ingresado es invalido."
            );
            return false;
        }
        /* 
              if (parseFloat(data.saldoInicialSoles)==0) {
                dialog.warning(
                  "Saldo inicial soles deber ser mayor a 0"
                );
                return false;
              }
              if (parseFloat(data.saldoInicialSoles)==0) {
                dialog.warning(
                  "Saldo inicial dolares deber ser mayor a 0"
                );
                return false;
              } */


        return true;
    };



    render() {

        const { getFieldDecorator } = this.props.form;
        getFieldDecorator('id', { initialValue: this.props.formValues.id });
        return (
            <Modal
                title={this.props.formValues.id === 0 ? "Registrar Apertura de Caja" : "Modificar Apertura de Caja"}
                visible={this.props.visible}
                cancelText={"Cancelar"}
                okText={"Guardar"}
                onCancel={this.handleCancel}
                onOk={this.handleOk}
                style={{ top: 30 }}
            >
                <Form>


                    <div className="row">

                        <div className="col-md-6">
                            <Form.Item label="Nro Planilla">


                                <InputGroup compact>
                                    <Form.Item style={{ width: "40%" }}>
                                        {getFieldDecorator("serie", {
                                            initialValue: this.props.formValues.serie,
                                            rules: [
                                                {
                                                    required: true,
                                                    message: "Requerido",
                                                },
                                            ],
                                        })(
                                            <Input
                                                readOnly
                                                className="text-right second-input"
                                                placeholder="Serie"
                                                autoComplete="off"

                                            />
                                        )}
                                    </Form.Item>
                                    <Form.Item style={{ width: "60%" }}>
                                        {getFieldDecorator("correlativo", {
                                            initialValue: this.props.formValues.correlativo,
                                            rules: [
                                                {
                                                    required: true,
                                                    message: "Correlativo",
                                                },
                                            ],
                                        })(
                                            <Input
                                                readOnly
                                                className="text-right second-input"
                                                placeholder="Ingresar Tipo de Cambio"
                                                autoComplete="off"

                                            />
                                        )}
                                    </Form.Item>
                                </InputGroup>


                            </Form.Item>
                        </div>
                        <div className="col-md-6">
                            <Form.Item label="Fecha Apertura">
                                <InputGroup compact>
                                    <Form.Item style={{ width: "100%" }}>
                                        {getFieldDecorator("FechaTipoCambio", {
                                            initialValue: moment(
                                                this.props.formValues.FechaTipoCambio,
                                                "DD/MM/YYYY"
                                            ),
                                            rules: [
                                                {
                                                    type: "object",
                                                    required: true,
                                                    message: "Requerido",
                                                },
                                            ],
                                        })(
                                            <DatePicker
                                                className="first-input"
                                                placeholder="Seleccione fecha"
                                                prefix={
                                                    <Icon
                                                        type="filter"
                                                        style={{ color: "rgba(0,0,0,.25)" }}
                                                    />
                                                }
                                                disabled={true}
                                                format="DD/MM/YYYY"
                                                onChange={(moment, value) =>
                                                    this.props.onChange(
                                                        "fechaStr",
                                                        value,
                                                        this.props.form
                                                    )
                                                }
                                            />
                                        )}
                                    </Form.Item>
                                    <Form.Item hidden={true} style={{ width: "35%" }}>
                                        {getFieldDecorator("TipoCambio", {
                                            initialValue: parseFloat(
                                                this.props.formValues.TipoCambio
                                            ).toFixed(3),
                                            rules: [
                                                {
                                                    required: true,
                                                    pattern: new RegExp(FORMAT_3DECIMALS),
                                                    message: "Formato decimal incorrecto (0.000)",
                                                },
                                            ],
                                        })(
                                            <Input
                                                className="text-right second-input"
                                                placeholder="Ingresar Tipo de Cambio"
                                                autoComplete="off"
                                                onBlur={(e) =>
                                                    this.handleCompleteDecimals(
                                                        "TipoCambio",
                                                        e.target.value
                                                    )
                                                }
                                            />
                                        )}
                                    </Form.Item>
                                </InputGroup>
                            </Form.Item>
                        </div>

                    </div>



                    <div className="row">
                        <div className="col-md-6">
                            <Form.Item label="Establecimiento">
                                {getFieldDecorator("idEstablecimiento", {
                                    initialValue: this.props.formValues.idEstablecimiento
                                        ? { key: this.props.formValues.idEstablecimiento }
                                        : undefined,
                                    rules: [
                                        {
                                            required: true,
                                            message: "Campo obligatorio.",
                                        },
                                    ],
                                })(
                                    <Select
                                        showSearch
                                        labelInValue
                                        placeholder={"Seleccione Establecimiento"}
                                        optionFilterProp="children"
                                        onChange={(option) => {
                                            this.props.form.setFieldsValue({
                                                idCaja: undefined,
                                            },
                                                () => { this.props.onChange(option.key, this.props.form) }
                                            );
                                        }}
                                    >
                                        {this.props.formValues.listaEstablecimiento.map((item) => (
                                            <Option key={item.id} value={item.id}>
                                                {item.nombre}
                                            </Option>
                                        ))}
                                    </Select>
                                )}
                            </Form.Item>
                        </div>
                        <div className="col-md-6">
                            <Form.Item label="Caja">
                                {getFieldDecorator("idCaja", {
                                    initialValue: this.props.formValues.idCaja
                                        ? { key: this.props.formValues.idCaja }
                                        : undefined,
                                    rules: [
                                        {
                                            required: true,
                                            message: "Campo obligatorio.",
                                        },
                                    ],
                                })(
                                    <Select
                                        showSearch
                                        labelInValue
                                        disabled={this.props.loadingChange}
                                        placeholder={"Seleccione Caja"}
                                        optionFilterProp="children"
                                    >
                                        {this.props.formValues.listaCaja.map((item) => (
                                            item.idTipoCaja == 1 ? <Option key={item.id} value={item.id}>
                                                {item.nombre}
                                            </Option> : null
                                        ))}
                                    </Select>
                                )}
                            </Form.Item>
                        </div>
                    </div>


                    <div className="row">
                        <div className="col-md-12">

                            <Form.Item label="Responsable de Manejo de Caja">


                                <InputGroup compact>
                                    <Form.Item style={{ width: "100%" }}>


                                        {getFieldDecorator("idResponsable", {
                                            initialValue: this.props.formValues.idResponsable
                                                ? { key: this.props.formValues.idResponsable }
                                                : undefined,
                                            rules: [
                                                {
                                                    required: true,
                                                    message: "Campo obligatorio.",
                                                },
                                            ],
                                        })(

                                            <Select
                                                showSearch
                                                labelInValue
                                                disabled={true}
                                                //style={{ width: `calc(100% - 40px)` }}
                                                placeholder={"Seleccione Caja"}
                                                optionFilterProp="children"
                                                showArrow={false}
                                            >
                                                {this.props.formValues.listaEmpleado.map(item => (
                                                    <Option key={item.id} value={item.id}>{item.nombre}</Option>
                                                ))}

                                            </Select>

                                        )}
                                    </Form.Item>

                                </InputGroup>


                            </Form.Item>

                        </div>
                        <div className="col-md-6">
                            <Form.Item label="Fecha cierre (Referencial)">
                                <InputGroup compact>
                                    <Form.Item >
                                        {getFieldDecorator("fechaReferencial", {
                                            initialValue: moment(
                                                this.props.formValues.fechaReferencial,
                                                "DD/MM/YYYY"
                                            ),
                                            rules: [
                                                {
                                                    type: "object",
                                                    required: true,
                                                    message: "Requerido",
                                                },
                                            ],
                                        })(
                                            <DatePicker
                                                className="first-input"
                                                placeholder="Seleccione fecha"
                                                prefix={
                                                    <Icon
                                                        type="filter"
                                                        style={{ color: "rgba(0,0,0,.25)" }}
                                                    />
                                                }
                                                allowClear={false}
                                                format="DD/MM/YYYY"

                                            />
                                        )}
                                    </Form.Item>

                                </InputGroup>
                            </Form.Item>
                        </div>
                        <div className="col-md-12 form-group">
                            <Divider orientation="center">Monto para aperturar</Divider>
                        </div>
                        <div className="col-md-6">
                            <Form.Item label="Monto PEN">
                                <InputGroup compact>
                                    <Form.Item>
                                        {getFieldDecorator(`saldoSoles`, {
                                            initialValue: parseFloat(this.props.formValues.saldoSoles).toFixed(2),
                                            rules: [{
                                                required: true,
                                                pattern: new RegExp(FORMAT_2DECIMALS),
                                                message: "Formato (0.00)"
                                            }
                                            ]
                                        })(
                                            <Input
                                                placeholder="Monto Pen"
                                                autoComplete="off"
                                                onKeyPress={global.onKeyPressDecimals}
                                                onBlur={(e) => {
                                                    this.props.form.setFieldsValue({
                                                        saldoSoles: global.onBlurDecimals(e, 2)
                                                    });
                                                }}
                                            />
                                        )}
                                    </Form.Item>

                                </InputGroup>
                            </Form.Item>
                        </div>

                        <div className="col-md-6">
                            <Form.Item label="Monto USD">
                                <InputGroup compact>
                                    <Form.Item>
                                        {getFieldDecorator(`saldoDolares`, {
                                            initialValue: parseFloat(this.props.formValues.saldoDolares).toFixed(2),
                                            rules: [{
                                                required: true,
                                                pattern: new RegExp(FORMAT_2DECIMALS),
                                                message: "Formato (0.00)"
                                            }
                                            ]
                                        })(
                                            <Input
                                                placeholder="Monto USD"
                                                autoComplete="off"
                                                onKeyPress={global.onKeyPressDecimals}
                                                onBlur={(e) => {
                                                    this.props.form.setFieldsValue({
                                                        saldoDolares: global.onBlurDecimals(e, 2)
                                                    });
                                                }}
                                            />
                                        )}
                                    </Form.Item>

                                </InputGroup>
                            </Form.Item>
                        </div>
                    </div>


                </Form>
            </Modal>
        );
    }
}
export default Form.create()(FormModal)